import { captureError, isEmpty, Storage } from "@swiggy-private/core-ui";
import {
    DINEOUT_CART_REFERRER_KEY,
    DINEOUT_CART_REFERRER_ID_KEY,
    DATING_REFERRER,
    REFERRER_QUERY_PARAM,
    REFERRER_ID_QUERY_PARAM,
} from "../constants";
import { IDatingFlowData } from "../interfaces";

export const getDatingFlowData = (): { referrer: string; referrerId: string } => {
    let referrer = "";
    let referrerId = "";

    try {
        referrer = Storage.getItem<string>(DINEOUT_CART_REFERRER_KEY) ?? "";
        referrerId = Storage.getItem<string>(DINEOUT_CART_REFERRER_ID_KEY) ?? "";
    } catch (err) {
        captureError(err);
    }

    return { referrer, referrerId };
};

export const isDatingFlow = (): boolean => {
    const { referrer, referrerId } = getDatingFlowData();

    return !isEmpty(referrer) && !isEmpty(referrerId) && referrer.toLowerCase() === DATING_REFERRER;
};

export const getReferrerDataFromQueryParams = (): IDatingFlowData => {
    const result: IDatingFlowData = {};

    try {
        if (typeof window !== "undefined" && window.location.search) {
            const params = new URLSearchParams(window.location.search);
            const referrer = params.get(REFERRER_QUERY_PARAM);
            const referrerIdParam = params.get(REFERRER_ID_QUERY_PARAM);

            if (!isEmpty(referrer)) {
                result.referrer = referrer;
            }
            if (!isEmpty(referrerIdParam)) {
                result.referrerId = referrerIdParam;
            }
        }
    } catch (error) {
        captureError(error);
    }

    return result;
};

export const saveReferrerData = (referrer?: string, referrerId?: number | string): void => {
    try {
        if (referrer) {
            Storage.setItem(DINEOUT_CART_REFERRER_KEY, referrer);
        }
        if (referrerId) {
            Storage.setItem(DINEOUT_CART_REFERRER_ID_KEY, String(referrerId));
        }
    } catch (err) {
        captureError(err);
    }
};

